<template>
  <div class="product" style="background-color: #EEEEEE;" v-if="show">
    <v-container fluid class="py-0">
      <v-row>
        <v-col class="py-0 px-0">
          <div style="position: relative;">
            <v-carousel
              height="calc(100vh - 120px)"
              :show-arrows="true"
              :show-arrows-on-hover="true"
              hide-delimiters
              v-model="carouselIndex"
              class="d-none d-md-block"
            >
              <v-carousel-item
                v-for="(image, image_id) in product.gallery"
                :key="'gallery-item-'+image_id"
              >
                <img :src="'https://www.artlesscms.actstudio.xyz/'+image.path" width="100%" style="height: calc(100vh - 120px); object-fit: contain">
              </v-carousel-item>

              <div
                class="v-carousel__controls"
                style="left: auto; right: auto; background-color: #EEEEEE;"
              >
                <div class="v-item-group">
                  <v-btn
                    text
                    color="transparent"
                    ripple
                    v-for="(image, image_id) in product.gallery"
                    :key="'gallery-index-'+image_id"
                    @click="carouselIndex = image_id"
                    min-width="25"
                    class="px-0"
                  >
                    <span
                      v-bind:class="{'color-gray':carouselIndex != image_id, 'bold': carouselIndex == image_id}"
                    >{{image_id + 1}}</span>
                  </v-btn>
                </div>
              </div>
            </v-carousel>

            <v-carousel
              :show-arrows="false"
              hide-delimiters
              v-model="carouselIndex"
              class="d-md-none"
            >
              <v-carousel-item
                v-for="(image, image_id) in product.gallery"
                :key="'gallery-item-'+image_id"
              >
                <v-img
                  :src="'https://www.artlesscms.actstudio.xyz/'+image.path"
                  width="100%"
                  height="100%"
                  contain
                ></v-img>
              </v-carousel-item>

              <div
                class="v-carousel__controls"
                style="left: auto; right: auto; background-color: #EEEEEE;"
              >
                <div class="v-item-group">
                  <v-btn
                    text
                    color="transparent"
                    ripple
                    v-for="(image, image_id) in product.gallery"
                    :key="'gallery-index-'+image_id"
                    @click="carouselIndex = image_id"
                    min-width="25"
                    class="px-0"
                  >
                    <span
                      v-bind:class="{'color-gray':carouselIndex != image_id, 'bold': carouselIndex == image_id}"
                    >{{image_id + 1}}</span>
                  </v-btn>
                </div>
              </div>
            </v-carousel>

            <v-avatar width="173" height="173" color="#211f1f" class="d-none d-2k-inline-flex d-4k-none" style="position: absolute; bottom: 39px; right: 39px; z-index: 1;">
              <span class="d-block color-white">
                <span class="d-block bold color-white">{{product.promotionTextRegilar}}</span>
                <span class="d-block color-white">
                  {{product.promotionTextBold}}
                </span>
              </span>
              </span>
            </v-avatar>

            <v-avatar width="133" height="133" color="#211f1f" class="d-none d-md-inline-flex d-2k-none" style="position: absolute; bottom: 30px; right: 30px; z-index: 1;">
              <span class="d-block color-white">
                <span class="d-block bold color-white">{{product.promotionTextRegilar}}</span>
                <span class="d-block color-white">
                  {{product.promotionTextBold}}
                </span>
              </span>
              </span>
            </v-avatar>

            <v-avatar width="225" height="225" color="#211f1f" class="d-none d-4k-inline-flex" style="position: absolute; bottom: 0px; right: 90px; z-index: 1;">
              <span class="d-block color-white">
                <span class="d-block bold color-white">{{product.promotionTextRegilar}}</span>
                <span class="d-block color-white">
                  {{product.promotionTextBold}}
                </span>
              </span>
              </span>
            </v-avatar>

          </div>
        </v-col>
      </v-row>
    </v-container>

    <v-container class="py-0">
      <v-row id="fabricsContainer" class="my-10">
        <v-col cols="12" offset-lg="1" lg="10" class="text-center text-md-left py-0">
          <span class="bold product-title">{{product.productNameLabelBold}}</span> <span class="product-title">{{product.productNameLabel}}</span>
        </v-col>
      </v-row>

      <v-row class="" style="min-height: 760px; position: relative;" v-if="!showFabrics">
        <v-col offset-lg="1" lg="3" class="d-none d-sm-block py-0">
          <span
            class="d-block bold product-link pointer"
            v-bind:class="{'active':activeSection == 0}"
            @click="activeSection = 0;"
          >Description</span>
          <span
            class="d-block bold product-link pointer"
            v-bind:class="{'active':activeSection == 1}"
            @click="activeSection = 1;"
          >Dimensions</span>
          <span
            class="d-block bold product-link pointer"
            v-bind:class="{'active':activeSection == 2}"
            @click="activeSection = 2;"
          >Materials</span>
          <span
            class="d-block bold product-link pointer"
            v-bind:class="{'active':activeSection == 3}"
            @click="activeSection = 3;"
          >Artless Care Guide</span>

          <!-- <div class="my-12">

            <template v-for="(swatchCategory,swc) in product.swatches">
              <div :key="'swatch-cat-'+swc">

                <template v-if="!swatchCategory.value.name.includes('Fabric') || swc == 0">
                  <div @click="showFabrics = true;" class="pointer uppercase" v-html="swatchCategory.value.name"></div>

                  <template v-if="swatchCategory.value.swatches.length > 0 && materialsLoaded">
                    <div class="mb-6 pointer" @click="showFabrics = true;">
                      <v-avatar class="d-2k-none" size="20"><v-img :src="'https://artlesscms.actstudio.xyz/'+getMaterial(swatchCategory.value.swatches[0]._id).cover.path"></v-img></v-avatar>

                      <v-avatar class="d-none d-2k-inline-flex d-4k-none" size="40"><v-img :src="'https://artlesscms.actstudio.xyz/'+getMaterial(swatchCategory.value.swatches[0]._id).cover.path"></v-img></v-avatar>

                      <v-avatar class="d-none d-4k-inline-flex" size="60"><v-img :src="'https://artlesscms.actstudio.xyz/'+getMaterial(swatchCategory.value.swatches[0]._id).cover.path"></v-img></v-avatar>

                      <span class="d-inline-block ml-8 btn-text underlined" v-if="swc == 0">REQUEST <span class="bold">SWATCH</span></span>
                    </div>
                    
                  </template>
                </template>
              </div>
            </template>

          </div> -->

          <v-btn class="btn-product mt-12" color="black" dark tile :ripple="false" :width="ancho" elevation="0" :height="alto" @click="showFabrics = true;">
            <span>
              <span class="d-block" style="color: white;">Swatch </span>
              <span class="d-block bold" style="color: white;">Request</span>
            </span>
          </v-btn>

          <br />
          <br />

          <v-btn :href="product.productLinkShop" class="btn-product" color="black" outlined tile :ripple="false" :height="alto" :width="ancho">
            <span class="tag-btn-shop-now">
              Shop <span class="bold tag-btn-shop-now"> Now</span>
            </span>
           
           </v-btn>

          <template v-if="hasFile(product.technicalDrawings)">
          

            <br />
            <br />
            
            <v-btn class="btn-product" color="black" dark tile :ripple="false" :width="ancho" elevation="0" :height="alto" :href="'https://artlesscms.actstudio.xyz/storage/uploads/'+product.technicalDrawings.path" target="_blank">
              <span>
                <span class="d-block" style="color: white;">Technical </span>
                <span class="d-block bold" style="color: white;">Drawings</span>
              </span>
            </v-btn>

          </template>

          <template v-if="variation">
          
            <br />
            <br />
            
            <v-btn :to="'/cs/product/'+product.variationLink.product.url" class="btn-product" color="black" outlined tile :ripple="false" :height="alto" :width="ancho">
              <span class="tag-btn-shop-now">
                CS <span class="bold tag-btn-shop-now"> Variation</span>
              </span>
            
            </v-btn>
          </template>

        </v-col>
        <v-col offset-lg="1" lg="6" xl="5" offset-xl="1" class="py-0">


          <!-- Inicia vista tablet y desktop  de la sección de info-->
          <div class="product-details d-none d-sm-block" v-if="activeSection == 0">
            <span class="bold d-block product-subtitle">Description</span>

            <template v-for="(detail_item, di) in product.details">

              <template v-if="detail_item.field.type == 'wysiwyg'">
                <div class="custom-links" :key="'detail-item-wysiwyg-'+di" v-html="detail_item.value">

                </div>
              </template>
              <template v-if="detail_item.field.type == 'text'">
                <span
                  class="bold d-block product-subtitle mt-2"
                  :key="'detail-item-'+di"
                >{{detail_item.value}}</span>
              </template>

              <template v-if="detail_item.field.type == 'textarea'">
                <p :key="'detail-item-'+di">{{detail_item.value}}</p>
              </template>

              <template v-if="detail_item.field.type == 'image'">
                <template v-if="width >= 3500">
                  <v-avatar :key="'detail-item-'+di" size="300">
                    <img :src="'https://artlesscms.actstudio.xyz/'+detail_item.value.path" />
                  </v-avatar>
                </template>
                <template v-else>
                  <v-avatar :key="'detail-item-'+di" size="200">
                    <img :src="'https://artlesscms.actstudio.xyz/'+detail_item.value.path" />
                  </v-avatar>
                </template>
              </template>
            </template>
          </div>
          <div class="product-dimensions d-none d-sm-block" v-if="activeSection == 1">
            <span class="bold d-block product-subtitle">Dimensions</span>
            <template v-for="(detail_item, di) in product.dimensions">
              <template v-if="detail_item.field.type == 'wysiwyg'">
                <div class="custom-links" :key="'dimension-item-'+di" v-html="detail_item.value"></div>
              </template>

              <template v-if="detail_item.field.type == 'text'">
                <span
                  class="bold d-block product-subtitle"
                  :key="'dimension-item-'+di"
                  style="white-space: break-lines;"
                >{{detail_item.value}}</span>
              </template>

              <template v-if="detail_item.field.type == 'textarea'">
                <p :key="'dimension-item-'+di" style="white-space: break-lines;">{{detail_item.value}}</p>
              </template>

              <template v-if="detail_item.field.type == 'image'">
                <v-img
                  :src="'https://artlesscms.actstudio.xyz/'+detail_item.value.path"
                  :key="'dimension-item-'+di"
                  width="100%"
                  class="mb-5"
                ></v-img>
              </template>
            </template>
          </div>
          <div class="product-materials d-none d-sm-block" v-if="activeSection == 2">
            <span class="bold d-block product-subtitle">Materials</span>

            <template v-for="(detail_item, di) in product.materials">
              <template v-if="detail_item.field.type == 'wysiwyg'">
                <div class="custom-links" :key="'materials-wysiwyg-'+di" v-html="detail_item.value"></div>
              </template>

              <template v-if="detail_item.field.type == 'text'">
                <span
                  class="bold d-block product-subtitle"
                  :key="'materials-item-'+di"
                >{{detail_item.value}}</span>
              </template>

              <template v-if="detail_item.field.type == 'textarea'">
                <p :key="'materials-item-'+di">{{detail_item.value}}</p>
              </template>

              <template v-if="detail_item.field.type == 'image'">
                <v-img
                  :src="'https://artlesscms.actstudio.xyz/'+detail_item.value.path"
                  :key="'materials-item-'+di"
                  width="100%"
                ></v-img>
              </template>

              <template v-if="detail_item.field.type == 'set'">
                <div :key="'materials-set-'+di">
                  <a
                    :href="'https://artlesscms.actstudio.xyz/'+detail_item.value.File.path"
                  >{{detail_item.value.Filename}}</a>
                </div>
              </template>

              <template v-if="detail_item.field.type == 'collectionlink'">
                <div :key="'material-category-'+di">

                  <div class="my-6" v-html="detail_item.value.name"></div>
                    <v-row>

                      <template v-for="(swatch, index) in swatches">
                        <template v-if="swatch.category._id == detail_item.value._id">
                          <v-col cols="auto" :key="'a-s-'+di+'-'+index" class="text-center" style="width: 150px;">
                            <router-link :to="'/materials/'+swatch.category.url">
                              <v-avatar size="80">
                                <v-img :src="'https://artlesscms.actstudio.xyz/'+swatch.cover.path"></v-img>
                              </v-avatar>
                            </router-link>
                            <span class="d-block mt-1">{{swatch.name}}</span>
                          </v-col>
                        </template>
                      </template>
                    </v-row>
                </div>
              </template>
            </template>
          </div>
          <div class="product-care-guide d-none d-sm-block" v-if="activeSection == 3">
            <span class="bold mb-5 d-block">ARTLESS CARE GUIDE</span>

            <template v-for="(detail_item, di) in product.caresGuides">
              <template v-if="detail_item.field.type == 'text'">
                <span
                  class="bold d-block product-subtitle"
                  :key="'dimension-item-'+di"
                >{{detail_item.value}}</span>
              </template>

              <template v-if="detail_item.field.type == 'textarea'">
                <p :key="'dimension-item-'+di">{{detail_item.value}}</p>
              </template>

              <template v-if="detail_item.field.type == 'image'">
                <v-img
                  :src="'https://artlesscms.actstudio.xyz/'+detail_item.value.path"
                  :key="'dimension-item-'+di"
                  width="100%"
                ></v-img>
              </template>

              <template v-if="detail_item.field.type == 'set'">
                <div class="text-center mt-10" :key="'dimension.set-'+di">
                  <v-btn
                    :href="'https://artlesscms.actstudio.xyz/storage/uploads/'+detail_item.value.File.path"
                    color="black"
                    class="d-2k-none"
                    dark
                    tile
                    elevation="0"
                    height="50"
                    min-width="200"
                    target="_blank"
                  ><span class="btn-text color-white">{{detail_item.value.Filename}}</span></v-btn>
                  <v-btn
                    :href="'https://artlesscms.actstudio.xyz/storage/uploads/'+detail_item.value.File.path"
                    color="black"
                    class="d-none d-2k-inline-flex"
                    dark
                    tile
                    elevation="0"
                    height="100"
                    min-width="400"
                    target="_blank"
                  ><span class="btn-text color-white">{{detail_item.value.Filename}}</span></v-btn>
                </div>
              </template>
            </template>
          </div>
          <!-- Termina vista tablet y desktop  de la sección de info-->


          <div class="d-sm-none px-6">
            <v-expansion-panels accordion flat tile v-model="ex">
              <v-expansion-panel>
                  <v-expansion-panel-header id="description-header" color="#EEEEEE" class="px-0">
                    <span class="bold">Description</span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content color="#EEEEEE">
                      <template v-for="(detail_item, di) in product.details">
                          <template v-if="detail_item.field.type == 'wysiwyg'">
                            <div class="custom-links" :key="'detail-item-mobile-wysiwyg-'+di" v-html="detail_item.value">

                            </div>
                          </template>
                          <template v-if="detail_item.field.type == 'text'">
                              <span
                              class="bold d-block product-subtitle"
                              :key="'detail-item-'+di"
                              >{{detail_item.value}}</span>
                          </template>

                          <template v-if="detail_item.field.type == 'textarea'">
                              <p :key="'detail-item-'+di">{{detail_item.value}}</p>
                          </template>

                          <template v-if="detail_item.field.type == 'image'">
                              <v-avatar :key="'detail-item-'+di" size="230">
                              <img :src="'https://artlesscms.actstudio.xyz/'+detail_item.value.path" />
                              </v-avatar>
                          </template>
                      </template>
                  </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                  <v-expansion-panel-header id="dimensions-header"  color="#EEEEEE" class="px-0">
                    <span class="bold">
                      Dimensions
                    </span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content color="#EEEEEE">
                      <template v-for="(detail_item, di) in product.dimensions">

                          <template v-if="detail_item.field.type == 'wysiwyg'">
                            <div class="custom-links" :key="'dimension-item-wysiwyh-'+di" v-html="detail_item.value"></div>
                          </template>

                          <template v-if="detail_item.field.type == 'text'">
                              <span
                              class="bold d-block product-subtitle"
                              :key="'dimension-item-'+di"
                              style="white-space: break-lines;"
                              >{{detail_item.value}}</span>
                          </template>

                          <template v-if="detail_item.field.type == 'textarea'" style="white-space: break-lines;">
                              <p :key="'dimension-item-'+di">{{detail_item.value}}</p>
                          </template>

                          <template v-if="detail_item.field.type == 'image'">
                              <v-img
                              :src="'https://artlesscms.actstudio.xyz/'+detail_item.value.path"
                              :key="'dimension-item-'+di"
                              width="100%"
                              ></v-img>
                          </template>
                      </template>
                  </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel>
                  <v-expansion-panel-header id="materials-header"  color="#EEEEEE" class="px-0">
                    <span class="bold">
                      Materials
                    </span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content color="#EEEEEE">
                      <template v-for="(detail_item, di) in product.materials">

                          <template v-if="detail_item.field.type == 'wysiwyg'">
                            <div class="custom-links" :key="'materials-wysiwyg-mobile-'+di" v-html="detail_item.value"></div>
                          </template>
                          <template v-if="detail_item.field.type == 'text'">
                              <span
                              class="bold d-block product-subtitle"
                              :key="'materials-item-'+di"
                              >{{detail_item.value}}</span>
                          </template>

                          <template v-if="detail_item.field.type == 'textarea'">
                              <p :key="'materials-item-'+di">{{detail_item.value}}</p>
                          </template>

                          <template v-if="detail_item.field.type == 'image'">
                              <v-img
                              :src="'https://artlesscms.actstudio.xyz/'+detail_item.value.path"
                              :key="'materials-item-'+di"
                              width="100%"
                              ></v-img>
                          </template>

                          <template v-if="detail_item.field.type == 'set'">
                              <div :key="'materials-set-'+di">
                              <a
                                  :href="'https://artlesscms.actstudio.xyz/'+detail_item.value.File.path"
                              >{{detail_item.value.Filename}}</a>
                              </div>
                          </template>
                          <template v-if="detail_item.field.type == 'collectionlink'">
                            <div :key="'material-category-'+di">

                              <div class="my-6" v-html="detail_item.value.name"></div>
                                <v-row>

                                  <template v-for="(swatch, index) in swatches">
                                    <template v-if="swatch.category._id == detail_item.value._id">
                                      <v-col cols="6" :key="'a-s-'+di+'-'+index" class="text-center">
                                        <router-link :to="'/materials/'+swatch.category.url">
                                          <v-avatar size="80">
                                            <v-img :src="'https://artlesscms.actstudio.xyz/'+swatch.cover.path"></v-img>
                                          </v-avatar>
                                        </router-link>
                                        <span class="d-block mt-1">{{swatch.name}}</span>
                                      </v-col>
                                    </template>
                                  </template>
                                </v-row>
                            </div>
                          </template>
                      </template>

                  </v-expansion-panel-content>
              </v-expansion-panel>


              <v-expansion-panel>
                  <v-expansion-panel-header id="cares-header"  color="#EEEEEE" class="px-0">
                    <span class="bold">
                      Artless Cares Guides
                    </span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content color="#EEEEEE">
                      <template v-for="(detail_item, di) in product.caresGuides">
                          <template v-if="detail_item.field.type == 'text'">
                              <span
                              class="bold d-block product-subtitle"
                              :key="'dimension-item-'+di"
                              >{{detail_item.value}}</span>
                          </template>

                          <template v-if="detail_item.field.type == 'textarea'">
                              <p :key="'dimension-item-'+di">{{detail_item.value}}</p>
                          </template>

                          <template v-if="detail_item.field.type == 'image'">
                              <v-img
                              :src="'https://artlesscms.actstudio.xyz/'+detail_item.value.path"
                              :key="'dimension-item-'+di"
                              width="100%"
                              ></v-img>
                          </template>

                          <template v-if="detail_item.field.type == 'set'">
                              <div class="text-center" :key="'dimension.set-'+di">
                              <v-btn
                                  :href="'https://artlesscms.actstudio.xyz/storage/uploads/'+detail_item.value.File.path"
                                  color="black"
                                  dark
                                  tile
                                  elevation="0"
                                  height="60"
                                  min-width="200"
                                  target="_blank"
                              >{{detail_item.value.Filename}}</v-btn>
                              </div>
                          </template>
                      </template>
                  </v-expansion-panel-content>
              </v-expansion-panel>


              <v-expansion-panel>
                  <v-expansion-panel-header id="swatches-header"  color="#EEEEEE" class="px-0">
                    <span class="bold">
                      View Fabrics
                    </span>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content color="#EEEEEE">

                    <template v-for="(category,c) in product.swatches">

                      <div :key="c" class="mt-10">
                        <div v-html="category.value.name" class="uppercase"></div>
                        <div class="mt-5">

                          <v-row>

                          
                            <template v-for="(material,m) in category.value.swatches">
                              <v-col cols="3" class="px-0" :key="c+'-'+m">

                              
                                <div
                                  class="d-inline-block text-center fabric-container mr-3 position-relative"
                                >

                                  <v-avatar
                                      color="black"
                                      size="48"
                                      class="pointer d-none d-4k-inline-flex"
                                      style="vertical-align: top; position: absolute; right: 10px; z-index: 4"
                                      v-if="hasMaterial(material._id,c)"
                                      @click="removeMaterial(material._id,c)"
                                    >
                                      <v-icon color="white" size="33">mdi-check</v-icon>

                                    </v-avatar>

                                    <v-avatar
                                      color="black"
                                      size="32"
                                      class="pointer d-none d-2k-inline-flex d-4k-none"
                                      style="vertical-align: top; position: absolute; right: 10px; z-index: 4"
                                      v-if="hasMaterial(material._id,c)"
                                      @click="removeMaterial(material._id,c)"
                                    >
                                      <v-icon color="white" size="22">mdi-check</v-icon>

                                    </v-avatar>
                                    <v-avatar
                                      color="black"
                                      size="16"
                                      class="pointer d-2k-none"
                                      style="vertical-align: top; position: absolute; right: 10px; z-index: 4"
                                      v-if="hasMaterial(material._id,c)"
                                      @click="removeMaterial(material._id,c)"
                                    >
                                      <v-icon color="white" size="11">mdi-check</v-icon>

                                    </v-avatar>

                                  <v-avatar :size="ancho_icono" @click="fabricsSelected = material._id; fabricsNumber = c;">
                                  <v-img
                                    :src="'https://artlesscms.actstudio.xyz/'+getMaterialCover(material._id)"
                                    class="mx-auto text-right align-self-start"
                                    >
                                    
                                  </v-img>
                                  </v-avatar>
                                  <span class="d-block">{{material.display}}</span>
                                </div>
                              </v-col>
                            </template>
                          </v-row>
                        </div>
                      </div>
                    </template>
                      

                      <v-btn color="black" block dark elevation="0" @click="dialogRequest = true;">Finish your request</v-btn>
                  </v-expansion-panel-content>
              </v-expansion-panel>


            </v-expansion-panels>

            <v-dialog v-model="dialogMobile" width="100%" class="mx-0 my-0" :fullscreen="true">


              <div style="position: fixed; top: 10px; right: 10px; z-index: 11; width: auto;">
                <v-icon @click="dialogMobile = false;">mdi-close</v-icon>
              </div>


              <v-card>
                
                <v-card-text class="text-center py-6">
                  <span class="bold d-block mb-10 currently-selected-title">CURRENTLY SELECTED</span>

                  <template v-for="(fabrics, fabrics_id) in product.swatch">
                    <template v-for="(material, material_id) in fabrics.materials">
                      <div
                        :key="fabrics._id + '-' + material_id"
                        v-if="fabricsSelected == fabrics._id + '-' + material_id"
                      >
                        <span class="bold">FABRICS {{fabrics_id + 1}}</span> <span>{{fabrics.name}}</span>

                        <span
                          class="bold d-block mb-10"
                          style="font-size: 26px;"
                        >{{material.value.MaterialName}}</span>

                        <v-avatar size="200" class="mb-10">
                          <v-img
                            :src="'https://artlesscms.actstudio.xyz/'+material.value.Image.path"
                          ></v-img>
                        </v-avatar>

                        <div class="mb-10">
                          <template v-if="!fabricsSelection.includes(material)">
                            <div @click="fabricsSelection.push(material)">
                              <v-avatar color="black" size="16" class="mx-4 d-2k-none">
                                <v-icon color="white" size="12">mdi-check</v-icon>
                              </v-avatar>
                              <v-avatar color="black" size="32" class="d-none d-2k-inline-flex d-4k-none mx-4">
                                <v-icon color="white" size="24">mdi-check</v-icon>
                              </v-avatar>
                              <v-avatar color="black" size="48" class="d-none d-4k-inline-flex mx-4">
                                <v-icon color="white" size="36">mdi-check</v-icon>
                              </v-avatar>
                              <span style="vertical-align: middle;">Request swatch</span>
                            </div>
                          </template>
                          <template v-else>
                            <div @click="remove(material)">
                              <v-avatar color="black" size="16" class="mx-4">
                                <v-icon color="white" size="12">mdi-close</v-icon>
                              </v-avatar>
                              <span style="vertical-align: middle;">Remove from your request list</span>
                            </div>
                          </template>
                        </div>

                        <p class="mb-6">{{fabrics.description}}</p>
                      </div>
                    </template>
                  </template>

                </v-card-text>
                <!-- <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="green darken-1" text @click="dialog = false">Disagree</v-btn>
                  <v-btn color="green darken-1" text @click="dialog = false">Agree</v-btn>
                </v-card-actions> -->
              </v-card>
            </v-dialog>

             <v-dialog v-model="dialogRequest" width="100%" class="mx-0 my-0" :fullscreen="true">


              <div style="position: fixed; top: 10px; right: 10px; z-index: 11; width: auto;">
                <v-icon @click="dialogRequest = false;">mdi-close</v-icon>
              </div>


              <v-card>

                <v-container>

                  
                  <v-row>
                    <v-col>
                      <span class="d-block bold">SWATCH REQUEST FORM</span>
                      <span class="bold product-extra">{{product.productNameLabelBold}}</span> <span class="product-extra">{{product.productNameLabel}}</span>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" v-for="(selection, selection_id) in fabricsSelection" :key="'fabricsSelection-'+selection_id">
                      <v-avatar class="d-inline-block" size="30" style="vertical-align: middle;">
                        <v-img :src="'https://www.artlesscms.actstudio.xyz/'+selection.value.Image.path"></v-img>
                      </v-avatar>
                      <div class="d-inline-block ml-4" style="vertical-align: middle;">
                        <span>{{selection.value.MaterialName}}</span>
                      </div>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <p>Your request will be processed within 3-5 days from receipt. First 3 swatches are free, after that there is a $3.00 fee per swatch; wood swatches are $5.00 each. An invoice will be sent to you once we receive your order. We will credit you if you buy with us or through one of our retailers.</p>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="6">
                      <v-text-field label="Email address"></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field label="City"></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="6">
                      <v-text-field label="Project or client reference"></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field label="State"></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="6">
                      <v-text-field label="Name"></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field label="Zip code"></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="6">
                      <v-text-field label="Street address"></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field label="Telephone number"></v-text-field>
                    </v-col>
                  </v-row>

                  
                </v-container>

                <v-row class="my-0">
                  <v-col class="py-0">
                    <v-btn block color="black" dark tile>
                      request
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-dialog>

          </div>
        </v-col>

        <div
          style="position: absolute; width: 100%; height: 100%; background-color: #E0E0E0;"
          v-if="false"
        >
          <v-container class="py-0" style="height: 100%;">
            <v-row style="height: 100%;">
              <v-col cols="4" class="text-center py-10" style="background-color: white;">
                <div class="mx-auto lateral-bar">
                  <span class="bold d-block mb-10 currently-selected-title">CURRENTLY SELECTED</span>

                  <template v-for="(fabrics, fabrics_id) in product.swatch">
                    <template v-for="(material, material_id) in fabrics.materials">
                      <div
                        :key="fabrics._id + '-' + material_id"
                        v-if="fabricsSelected == fabrics._id + '-' + material_id"
                      >
                        <span class="bold">FABRICS {{fabrics_id + 1}}</span> <span>{{fabrics.name}}</span>

                        <span
                          class="bold d-block mb-10"
                          style="font-size: 26px;"
                        >{{material.value.MaterialName}}</span>

                        <v-avatar size="200" class="mb-10">
                          <v-img
                            :src="'https://artlesscms.actstudio.xyz/'+material.value.Image.path"
                          ></v-img>
                        </v-avatar>

                        <div class="mb-10">
                          <template v-if="!fabricsSelection.includes(material)">
                            <div @click="fabricsSelection.push(material)">
                              <v-avatar color="black" size="16" class="mx-4 d-2k-none">
                                <v-icon color="white" size="12">mdi-check</v-icon>
                              </v-avatar>
                              <v-avatar color="black" size="32" class="mx-4 d-none d-2k-inline-flex d-4k-none">
                                <v-icon color="white" size="24">mdi-check</v-icon>
                              </v-avatar>
                              <v-avatar color="black" size="48" class="mx-4 d-none d-4k-inline-flex">
                                <v-icon color="white" size="36">mdi-check</v-icon>
                              </v-avatar>
                              <span style="vertical-align: middle;">Request swatch</span>
                            </div>
                          </template>
                          <template v-else>
                            <div @click="removeMaterial(material,fabricsNumber)">
                              <v-avatar color="black" size="16" class="mx-4 d-2k-none">
                                <v-icon color="white" size="12">mdi-close</v-icon>
                              </v-avatar>
                              <v-avatar color="black" size="32" class="mx-4 d-none d-2k-inline-flex d-4k-none">
                                <v-icon color="white" size="24">mdi-close</v-icon>
                              </v-avatar>
                              <v-avatar color="black" size="48" class="mx-4 d-none d-4k-inline-flex">
                                <v-icon color="white" size="36">mdi-close</v-icon>
                              </v-avatar>
                              <span style="vertical-align: middle;">Remove swatch</span>
                            </div>
                          </template>
                        </div>

                        <p class="mb-6">{{fabrics.description}}</p>
                      </div>
                    </template>
                  </template>
                </div>
              </v-col>
              <v-col lg="8" class="py-10 px-6" style="position: relative;">
                <div class="mx-auto" style="max-width: 868px;">

                  <!-- <span class="bold btn-text">CHANGE FABRIC</span> -->

                  <template v-for="(fabrics, fabrics_id) in product.swatch">
                    <div :key="fabrics._id" class="mt-10">
                      <span class="bold uppercase">Fabrics {{fabrics_id + 1}}</span> <span class="uppercase">{{fabrics.name}}</span>
                      <div class="mt-5">
                        <template v-for="(material, material_id) in fabrics.materials">
                          <div
                            class="d-inline-block text-center fabric-container"
                            :key="fabrics._id+'-'+material_id"
                            :a="fabrics._id+'-'+material_id"
                          >
                            <v-img
                              :src="'https://artlesscms.actstudio.xyz/'+material.value.Image.path"
                              :width="ancho_iconos"
                              :height="alto_iconos"
                              class="mx-auto text-right align-self-start"
                              @click="fabricsSelected = fabrics._id + '-' + material_id"
                            >
                              <v-avatar
                                color="black"
                                size="32"
                                class="pointer d-none d-4k-inline-flex"
                                style="vertical-align: top;"
                                v-if="fabricsSelection.includes(material)"
                                @click="remove(material)"
                              >
                                <v-icon color="white" size="33">mdi-check</v-icon>

                              </v-avatar>

                              <v-avatar
                                color="black"
                                size="32"
                                class="pointer d-none d-2k-inline-flex d-4k-none"
                                style="vertical-align: top;"
                                v-if="fabricsSelection.includes(material)"
                                @click="remove(material)"
                              >
                                <v-icon color="white" size="22">mdi-check</v-icon>

                              </v-avatar>
                              <v-avatar
                                color="black"
                                size="16"
                                class="pointer d-2k-none"
                                style="vertical-align: top;"
                                v-if="fabricsSelection.includes(material)"
                                @click="remove(material)"
                              >
                                <v-icon color="white" size="11">mdi-check</v-icon>

                              </v-avatar>
                            </v-img>
                            <span class="d-block">{{material.value.MaterialName}}</span>
                          </div>
                        </template>
                      </div>
                    </div>
                  </template>

                </div>



                  <div style="position: absolute; bottom: 0px; width: 100%">
                    <v-btn dark color="black" tile :ripple="false" elevation="0" block @click="dialog = true;">request</v-btn>
                  </div>

                <v-dialog v-model="dialog" persistent :content-class="'background-grey'">
                  <div style="position: relative;">
                    <v-icon @click="dialog = false" style="position: absolute; top: 10px; right: 10px;">mdi-close</v-icon>
                    <v-container>
                      <v-row>
                        <v-col>
                          <span class="d-block bold">SWATCH REQUEST FORM</span>
                          <span class="bold product-extra">{{product.productNameLabelBold}}</span> <span class="product-extra">{{product.productNameLabel}}</span>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="auto" v-for="(selection, selection_id) in fabricsSelection" :key="'fabricsSelection-'+selection_id">
                          <v-avatar class="d-inline-block" size="30" style="vertical-align: middle;">
                            <v-img :src="'https://www.artlesscms.actstudio.xyz/'+selection.value.Image.path"></v-img>
                          </v-avatar>
                          <div class="d-inline-block ml-4" style="vertical-align: middle;">
                            <span>{{selection.value.MaterialName}}</span>
                          </div>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <p>Your request will be processed within 3-5 days from receipt. First 3 swatches are free, after that there is a $3.00 fee per swatch; wood swatches are $5.00 each. An invoice will be sent to you once we receive your order. We will credit you if you buy with us or through one of our retailers.</p>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="6">
                          <v-text-field label="Email address"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field label="City"></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="6">
                          <v-text-field label="Project or client reference"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field label="State"></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="6">
                          <v-text-field label="Name"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field label="Zip code"></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="6">
                          <v-text-field label="Street address"></v-text-field>
                        </v-col>
                        <v-col cols="6">
                          <v-text-field label="Telephone number"></v-text-field>
                        </v-col>
                      </v-row>

                    </v-container>

                    <v-btn color="black" dark tile :ripple="false" elevation="0" @click="dialog = false;" width="100%">send request</v-btn>
                  </div>


                </v-dialog>
              </v-col>
            </v-row>
          </v-container>

          <v-icon
            @click="showFabrics = false;"
            style="position: absolute; top: 10px; right: 10px;"
          >mdi-close</v-icon>
        </div>
      </v-row>

      <div v-if="showFabrics" style="position: relative;">

        <v-icon
            @click="showFabrics = false;"
            style="position: absolute; top: 10px; right: 10px;z-index: 3;"
            class="d-2k-none"
          >mdi-close</v-icon>
        <v-icon
            @click="showFabrics = false;"
            style="position: absolute; top: 10px; right: 10px; z-index: 3;"
            class="d-none d-2k-block"
            size="40"
          >mdi-close</v-icon>
        <v-row style="height: 100%; background-color: rgb(210,210,210)">
          <v-col cols="4" class="text-center py-10" style="background-color: white;">
            <div class="mx-auto lateral-bar">
              <span class="bold d-block mb-10 currently-selected-title">CURRENTLY SELECTED</span>


              <div v-if="fabricsSelected != 0 && getMaterial(fabricsSelected) != false">

                <div v-html="getMaterial(fabricsSelected).category.name"></div>
                <!-- <span class="bold">FABRICS {{fabrics_id + 1}}</span> <span>{{fabrics.name}}</span> -->

                <span
                  class="bold d-block mb-10 currently-selected-material-name"
                >{{getMaterial(fabricsSelected).name}}</span>

                <v-avatar size="200" class="mb-10">
                  <v-img
                    :src="'https://artlesscms.actstudio.xyz/'+getMaterial(fabricsSelected).cover.path"
                  ></v-img>
                </v-avatar>



                <div class="mb-10">
                  <template v-if="!hasMaterial(fabricsSelected,fabricsNumber)">
                    <div class="pointer" @click="addMaterial(fabricsSelected,fabricsNumber)">
                      <v-avatar color="black" size="48" class="mx-4 d-none d-4k-inline-flex">
                        <v-icon color="white" size="36">mdi-check</v-icon>
                      </v-avatar>
                      <v-avatar color="black" size="32" class="mx-4 d-none d-2k-inline-flex d-4k-none">
                        <v-icon color="white" size="24">mdi-check</v-icon>
                      </v-avatar>
                      <v-avatar color="black" size="16" class="mx-4 d-2k-none">
                        <v-icon color="white" size="12">mdi-check</v-icon>
                      </v-avatar>

                      <!-- Desktop -->
                      <span style="vertical-align: middle;">Request swatch</span>
                    </div>
                  </template>
                  <template v-else>
                    <div class="pointer" @click="removeMaterial(fabricsSelected,fabricsNumber)">
                      <v-avatar color="black" size="48" class="mx-4 d-none d-4k-inline-flex">
                        <v-icon color="white" size="36">mdi-close</v-icon>
                      </v-avatar>
                      <v-avatar color="black" size="32" class="mx-4 d-none d-2k-inline-flex d-4k-none">
                        <v-icon color="white" size="24">mdi-close</v-icon>
                      </v-avatar>
                      <v-avatar color="black" size="16" class="mx-4 d-2k-none">
                        <v-icon color="white" size="12">mdi-close</v-icon>
                      </v-avatar>

                      <!-- Desktop -->
                      <span style="vertical-align: middle;">Remove swatch</span>
                    </div>
                  </template>
                </div>

                <p class="mb-6">{{getMaterial(fabricsSelected).description}}</p>
              </div>

              
            </div>
          </v-col>
          <v-col lg="8" class="pb-10 px-0 pt-0" style="position: relative;">
            <div class="mx-auto px-6 pb-12" style="max-width: 868px;">
              

              <!-- Desktop -->
              <span class="bold d-block mt-10 currently-selected-title">SELECT SWATCHES</span>

              <template v-for="(category,c) in product.swatches">

                <div :key="c" class="mt-10">
                  <div v-html="category.value.name" class="uppercase"></div>
                  <div class="mt-5">

                    <v-row>

                    
                      <template v-for="(material,m) in category.value.swatches">
                        <template v-if="getMaterialCover(material._id) != false">
                          <v-col cols="auto" class="px-0" :key="c+'-'+m">

                            <div
                              class="d-inline-block text-center fabric-container mr-3 position-relative"
                              @click="addMaterial(material._id,c)"
                              v-if="!hasMaterial(material._id,c)"
                            >

                            
                              <v-avatar
                                  color="black"
                                  size="48"
                                  class="pointer d-none d-4k-inline-flex"
                                  style="vertical-align: top; position: absolute; right: 10px; z-index: 4"
                                  v-if="hasMaterial(material._id,c)"
                                  @click="removeMaterial(material._id,c)"
                                >
                                  <v-icon color="white" size="33">mdi-check</v-icon>

                                </v-avatar>

                                <v-avatar
                                  color="black"
                                  size="32"
                                  class="pointer d-none d-2k-inline-flex d-4k-none"
                                  style="vertical-align: top; position: absolute; right: 10px; z-index: 4"
                                  v-if="hasMaterial(material._id,c)"
                                  @click="removeMaterial(material._id,c)"
                                >
                                  <v-icon color="white" size="22">mdi-check</v-icon>

                                </v-avatar>
                                <v-avatar
                                  color="black"
                                  size="16"
                                  class="pointer d-2k-none"
                                  style="vertical-align: top; position: absolute; right: 10px; z-index: 4"
                                  v-if="hasMaterial(material._id,c)"
                                  @click="removeMaterial(material._id,c)"
                                >
                                  <v-icon color="white" size="11">mdi-check</v-icon>

                                </v-avatar>

                              <v-avatar :size="ancho_icono" @click="fabricsSelected = material._id; fabricsNumber = c;">
                              <v-img
                                :src="'https://artlesscms.actstudio.xyz/'+getMaterialCover(material._id)"
                                class="mx-auto text-right align-self-start"
                                >
                                
                              </v-img>
                              </v-avatar>
                              <span class="d-block">{{getMaterial(material._id).name}}</span>
                            </div>

                            <div
                              class="d-inline-block text-center fabric-container mr-3 position-relative"
                              @click="removeMaterial(material._id,c)"
                              v-if="hasMaterial(material._id,c)"
                            >

                              <v-avatar
                                  color="black"
                                  size="48"
                                  class="pointer d-none d-4k-inline-flex"
                                  style="vertical-align: top; position: absolute; right: 10px; z-index: 4"
                                  v-if="hasMaterial(material._id,c)"
                                  @click="removeMaterial(material._id,c)"
                                >
                                  <v-icon color="white" size="33">mdi-check</v-icon>

                                </v-avatar>

                                <v-avatar
                                  color="black"
                                  size="32"
                                  class="pointer d-none d-2k-inline-flex d-4k-none"
                                  style="vertical-align: top; position: absolute; right: 10px; z-index: 4"
                                  v-if="hasMaterial(material._id,c)"
                                  @click="removeMaterial(material._id,c)"
                                >
                                  <v-icon color="white" size="22">mdi-check</v-icon>

                                </v-avatar>
                                <v-avatar
                                  color="black"
                                  size="16"
                                  class="pointer d-2k-none"
                                  style="vertical-align: top; position: absolute; right: 10px; z-index: 4"
                                  v-if="hasMaterial(material._id,c)"
                                  @click="removeMaterial(material._id,c)"
                                >
                                  <v-icon color="white" size="11">mdi-check</v-icon>

                                </v-avatar>

                              <v-avatar :size="ancho_icono" @click="fabricsSelected = material._id; fabricsNumber = c;">
                              <v-img
                                :src="'https://artlesscms.actstudio.xyz/'+getMaterialCover(material._id)"
                                class="mx-auto text-right align-self-start"
                                >
                                
                              </v-img>
                              </v-avatar>
                              <span class="d-block">{{getMaterial(material._id).name}}</span>
                            </div>
                          </v-col>
                        </template>
                      </template>
                    </v-row>
                  </div>
                </div>
              </template>

              

            </div>



              <div style="position: absolute; bottom: 0px; width: 100%">
                <v-btn dark color="black" tile :ripple="false" elevation="0" block @click="dialog = true;" class="btn-request d-none d-4k-block" height="105px">
                  <span class="white--text"> swatch </span> <span class="white--text bold"> request </span>
                  
                </v-btn>

                <v-btn dark color="black" tile :ripple="false" elevation="0" block @click="dialog = true;" class="btn-request d-none d-2k-block d-4k-none" height="70px">
                  <span class="white--text"> swatch </span> <span class="white--text bold"> request </span>
                </v-btn>

                <v-btn dark color="black" tile :ripple="false" elevation="0" block @click="dialog = true;" class="btn-request d-2k-none">
                  <span class="white--text"> swatch </span> <span class="white--text bold"> request </span>
                </v-btn>

                
              </div>

            <v-dialog v-model="dialog" persistent :content-class="'background-grey'">
              <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
                <div style="position: relative;">
                  <v-icon @click="dialog = false" style="position: absolute; top: 10px; right: 10px;" class="d-none d-2k-inline-flex" size="36">mdi-close</v-icon>
                  <v-icon @click="dialog = false" style="position: absolute; top: 10px; right: 10px;" class="d-2k-none">mdi-close</v-icon>
                  <v-container>
                    <v-row>
                      <v-col>
                        <!-- Desktop -->
                        <span class="d-block bold">SWATCH REQUEST FORM</span>
                        <span class="bold product-extra">{{product.productNameLabelBold}}</span> <span class="product-extra">{{product.productNameLabel}}</span>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="auto" v-for="(material, mid) in materials1" :key="'fabricsSelection-1-'+mid">
                        <v-avatar class="d-inline-block" size="30" style="vertical-align: middle;">
                          <v-img :src="'https://www.artlesscms.actstudio.xyz/'+getMaterial(material).cover.path"></v-img>
                        </v-avatar>
                        <div class="d-inline-block ml-4" style="vertical-align: middle;">
                          <span>{{getMaterial(material).name}}</span>
                        </div>
                      </v-col>

                      <v-col cols="auto" v-for="(material, mid) in materials2" :key="'fabricsSelection-2-'+mid">
                        <v-avatar class="d-inline-block" size="30" style="vertical-align: middle;">
                          <v-img :src="'https://www.artlesscms.actstudio.xyz/'+getMaterial(material).cover.path"></v-img>
                        </v-avatar>
                        <div class="d-inline-block ml-4" style="vertical-align: middle;">
                          <span>{{getMaterial(material).name}}</span>
                        </div>
                      </v-col>


                      <v-col cols="auto" v-for="(material, mid) in materials3" :key="'fabricsSelection-3-'+mid">
                        <v-avatar class="d-inline-block" size="30" style="vertical-align: middle;">
                          <v-img :src="'https://www.artlesscms.actstudio.xyz/'+getMaterial(material).cover.path"></v-img>
                        </v-avatar>
                        <div class="d-inline-block ml-4" style="vertical-align: middle;">
                          <span>{{getMaterial(material).name}}</span>
                        </div>
                      </v-col>

                      <v-col cols="auto" v-for="(material, mid) in materials4" :key="'fabricsSelection-4-'+mid">
                        <v-avatar class="d-inline-block" size="30" style="vertical-align: middle;">
                          <v-img :src="'https://www.artlesscms.actstudio.xyz/'+getMaterial(material).cover.path"></v-img>
                        </v-avatar>
                        <div class="d-inline-block ml-4" style="vertical-align: middle;">
                          <span>{{getMaterial(material).name}}</span>
                        </div>
                      </v-col>

                      <v-col cols="auto" v-for="(material, mid) in materials5" :key="'fabricsSelection-5-'+mid">
                        <v-avatar class="d-inline-block" size="30" style="vertical-align: middle;">
                          <v-img :src="'https://www.artlesscms.actstudio.xyz/'+getMaterial(material).cover.path"></v-img>
                        </v-avatar>
                        <div class="d-inline-block ml-4" style="vertical-align: middle;">
                          <span>{{getMaterial(material).name}}</span>
                        </div>
                      </v-col>
                      
                    </v-row>

                    <v-row>
                      <v-col>
                        <p>Your request will be processed within 3-5 days from receipt. First 3 swatches are free, after that there is a $3.00 fee per swatch; wood swatches are $5.00 each. An invoice will be sent to you once we receive your order. We will credit you if you buy with us or through one of our retailers.</p>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="6">
                        <v-text-field label="Email address" class="d-2k-none" v-model="SRemail" :rules="requiredRules" color="gray"></v-text-field>

                        <v-text-field label="Email address" class="d-none d-2k-flex" height="64" v-model="SRemail" :rules="requiredRules" color="gray"></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field label="City" class="d-2k-none" v-model="SRcity" :rules="requiredRules" color="gray"></v-text-field>
                        <v-text-field label="City" class="d-none d-2k-flex" height="64" v-model="SRcity" :rules="requiredRules" color="gray"></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="6">
                        <v-text-field label="Project or client reference" class="d-2k-none" v-model="SRproject" color="gray"></v-text-field>
                        <v-text-field label="Project or client reference" class="d-none d-2k-flex" height="64" v-model="SRproject" color="gray"></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field label="State" class="d-2k-none" v-model="SRstate" :rules="requiredRules" color="gray"></v-text-field>
                        <v-text-field label="State" class="d-none d-2k-flex" height="64" v-model="SRstate" :rules="requiredRules" color="gray"></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="6">
                        <v-text-field label="Name" class="d-2k-none" v-model="SRname" :rules="requiredRules" color="gray"></v-text-field>
                        <v-text-field label="Name" class="d-none d-2k-flex" height="64" v-model="SRname" :rules="requiredRules" color="gray"></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field label="Zip code" class="d-2k-none" v-model="SRzip" :rules="requiredRules" color="gray"></v-text-field>
                        <v-text-field label="Zip code" class="d-none d-2k-flex" height="64" v-model="SRzip" :rules="requiredRules" color="gray"></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="6">
                        <v-text-field label="Street address" class="d-2k-none" v-model="SRstreet" :rules="requiredRules" color="gray"></v-text-field>
                        <v-text-field label="Street address" class="d-none d-2k-flex" height="64" v-model="SRstreet" :rules="requiredRules" color="gray"></v-text-field>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field label="Telephone number" class="d-2k-none" v-model="SRphone" color="gray"></v-text-field>
                        <v-text-field label="Telephone number" class="d-none d-2k-flex" height="64" v-model="SRphone" color="gray"></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col>
                        <span>* Required info</span>
                      </v-col>
                    </v-row>

                  </v-container>


                  <v-btn color="black" dark tile :ripple="false" elevation="0" @click="sendRequest(); " width="100%" class="btn-request d-none d-2k-block" height="70px">send  &nbsp;<span class="bold white--text">request</span> </v-btn>
                  <v-btn color="black" dark tile :ripple="false" elevation="0" @click="sendRequest();" width="100%" class="btn-request d-2k-none">send &nbsp; <span class="bold white--text">request</span> </v-btn>
                </div>

              </v-form>


            </v-dialog>
          </v-col>
        </v-row>
      </div>

      <v-row class="pb-10 my-2k-6 product-warranties" v-bind:class="{'invisible-border-top':showFabrics}">
        <v-col offset-lg="1" lg="10" class="py-0">
          <v-row>
            <v-col cols="12" sm="4" class="text-center px-lg-12">
              <v-img
                src="../assets/img/icons/la-made.svg"
                height="82"
                width="133"
                class="mx-auto my-10 my-sm-12 d-2k-none"
                contain
              ></v-img>
              <v-img
                src="../assets/img/icons/la-made.svg"
                height="164"
                width="266"
                class="mx-auto my-10 my-sm-12 d-none d-2k-flex d-4k-none"
                contain
              ></v-img>
              <v-img
                src="../assets/img/icons/la-made.svg"
                height="246"
                width="399"
                class="mx-auto my-10 my-sm-12 d-none d-4k-flex"
                contain
              ></v-img>
              {{info.lamadeText}}
              
            </v-col>
            <v-col cols="12" sm="4" class="text-center px-lg-12">
              <v-img
                src="../assets/img/icons/check-configuration.svg"
                height="82"
                width="73"
                class="mx-auto my-10 my-sm-12 d-2k-none"
                contain
              ></v-img>
              <v-img
                src="../assets/img/icons/check-configuration.svg"
                height="164"
                width="146"
                class="mx-auto my-10 my-sm-12 d-none d-2k-flex d-4k-none"
                contain
              ></v-img>
              <v-img
                src="../assets/img/icons/check-configuration.svg"
                height="246"
                width="219"
                class="mx-auto my-10 my-sm-12 d-none d-4k-flex"
                contain
              ></v-img>
              {{info.warranty}}
            </v-col>
            <v-col cols="12" sm="4" class="text-center px-lg-12">
              <v-img
                src="../assets/img/icons/4weeks.svg"
                height="82"
                width="61"
                class="mx-auto my-10 my-sm-12 d-2k-none"
                contain
              ></v-img>
              <v-img
                src="../assets/img/icons/4weeks.svg"
                height="164"
                width="122"
                class="mx-auto my-10 my-sm-12 d-none d-2k-flex d-4k-none"
                contain
              ></v-img>
              <v-img
                src="../assets/img/icons/4weeks.svg"
                height="246"
                width="183"
                class="mx-auto my-10 my-sm-12 d-none d-4k-flex"
                contain
              ></v-img>
              {{info.deliveryTime}}

              <a :href="info.collectiveSelectiveLink" target="_blank">
                <v-img :src="'https://artlesscms.actstudio.xyz/'+info.collectiveSelectiveLogo.path" max-width="200px" class="mx-auto mt-5"></v-img>
              </a>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="py-6 py-sm-12">
        <v-col class="text-center">
          <span class="bold product-title">You may</span> <span class="product-title">also like</span>
        </v-col>
      </v-row>

      <v-row v-if="firstRelated != null">
        <v-col lg="6" class="text-center pb-12">

          <router-link :to="'/product/'+firstRelated.url">
            <v-img
              :src="'https://www.artlesscms.actstudio.xyz/'+firstRelated.gallery[0].path"
              width="100%"
              class="mb-6"
            ></v-img>
          </router-link>

          <router-link class="not-text-decoration" :to="'/product/'+firstRelated.url">
            <span class="bold product-extra">{{firstRelated.productNameLabelBold}} </span>
            <span class="product-extra">{{firstRelated.productNameLabel}}</span>
          </router-link>
        </v-col>
        <v-col lg="6" class="text-center pb-12">
          <router-link :to="'/product/'+secondRelated.url">
            <v-img
              :src="'https://www.artlesscms.actstudio.xyz/'+secondRelated.gallery[0].path"
              width="100%"
              class="mb-6"
            ></v-img>
          </router-link>

          <router-link class="not-text-decoration" :to="'/product/'+secondRelated.url">
            <span class="bold product-extra">{{secondRelated.productNameLabelBold}} </span>
            <span class="product-extra">{{secondRelated.productNameLabel}}</span>
          </router-link>
        </v-col>
      </v-row>
    </v-container>

    <v-snackbar v-model="snackbar" color="#221f1f">
      <span class="white--text text-center">
        THANK <span class="bold white--text">YOU!</span>
      </span>

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

  </div>
</template>

<script>
import Vue from "vue";
import VueScrollTo from "vue-scrollto";

Vue.use(VueScrollTo);

export default {
  data() {
    return {
      valid: true,
      requiredRules: [
        v => !!v || '* Required'
      ],
      ex: 0,
      snackbar: false,
      fabricsNumber: -1,
      show: false,
      product: {},
      products: [],
      activeSection: 0,
      carouselIndex: 0,
      showFabrics: false,
      fabricsSelection: [],
      fabricsSelected: 0,
      dialog: false,
      dialogMobile: false,
      dialogRequest: false,
      materials: [],
      firstRelated: null,
      secondRelated: null,
      info: {
        deliveryTime: "",
        lamadeText: "",
        warranty: "",
      },
      productLoaded: false,
      productsLoaded: false,
      swatches: [],
      materialsLoaded: false,
      material: null,
      materials1:[],
      materials2:[],
      materials3:[],
      materials4:[],
      materials5:[],
      SRemail: '',
      SRcity: '',
      SRproject: '',
      SRstate: '',
      SRname: '',
      SRzip: '',
      SRstreet: '',
      SRphone: '',
      collection: {}
    };
  },
  beforeMount: function () {
    var aux = this;

    fetch(
      "https://www.artlesscms.actstudio.xyz/api/collections/get/Collection?token=a15be93e9cdb43ca2b3778c2077c26",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          populate: 1, // resolve linked collection items
          filter:{
              url: this.$route.query.serie
          }
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => (aux.collection = res.entries[0]));

    fetch(
      "https://www.artlesscms.actstudio.xyz/api/collections/get/Products?token=a15be93e9cdb43ca2b3778c2077c26",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          filter: {
            url: this.$route.params.url,
          },
          sort:{

          },
          populate: 3, // resolve linked collection items
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => (this.product = res.entries[0]))
      .then(function (res) {
        aux.fabricsSelected = aux.product.swatch[0]._id + "-" + 0;
        aux.show = true;
        aux.productLoaded = true;
      })
      .then(() => {
        var breadcrumbs = [];
        if(this.$route.query.serie != undefined){
          breadcrumbs = [
            {
              text: "Home",
              link: "/",
              isLink: true,
            },
            {
              text: this.collection.name,
              link: "/series/"+this.collection.url,
              isLink: true,
            },
            {
              text: this.product.name,
              link: "/product/" + this.product.url,
              isLink: false,
            },
          ];
        }else{

          breadcrumbs = [
            {
              text: "Home",
              link: "/",
              isLink: true,
            },
            {
              text: "Furniture",
              link: "/furniture",
              isLink: true,
            },
            {
              text: this.product.category.name,
              link: "/furniture/"+this.product.category.url,
              isLink: true
            },
            {
              text: this.product.name,
              link: "/product/" + this.product.url,
              isLink: false,
            },
          ];
        }
        this.$emit("updateStatus", breadcrumbs);
      })
      .then(() => this.getRelated());

    fetch(
      "https://www.artlesscms.actstudio.xyz/api/collections/get/Products?token=a15be93e9cdb43ca2b3778c2077c26",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          filter: {},
          populate: 1, // resolve linked collection items
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => (this.products = res.entries))
      .then(() => (this.productsLoaded = true))
      .then(() => this.getRelated());

    fetch(
      "https://www.artlesscms.actstudio.xyz/api/collections/get/Materials?token=a15be93e9cdb43ca2b3778c2077c26",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          filter: {},
          populate: 2, // resolve linked collection items
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => (this.materials = res.entries))
      .then(() => (this.materialsLoaded = true));

    fetch(
      "https://www.artlesscms.actstudio.xyz/api/singletons/get/ProductInfo?token=a15be93e9cdb43ca2b3778c2077c26"
    )
      .then((data) => data.json())
      .then((data) => (this.info = data));

    fetch(
      "https://www.artlesscms.actstudio.xyz/api/collections/get/Materials?token=a15be93e9cdb43ca2b3778c2077c26",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          populate: 1, // resolve linked collection items
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => (this.swatches = res.entries));
  },
  methods: {
    hasFile: function(field){
      if(field != undefined){
        if(field.path != undefined){
          return true;
        }
      }

      return false;
    },
    getMaterialField: function(){
      
      var aux = this;
      var object = {
        'ProductName':aux.product.name,
        'Email': aux.SRemail,
        'City': aux.SRcity,
        'Project': aux.SRproject,
        'State': aux.SRstate,
        'Name': aux.SRname,
        'ZipCode': aux.SRzip,
        'Street': aux.SRstreet,
        'Phone': aux.SRphone
      };

      var n = 0;

      for (let index = 0; index < this.materials1.length; index++) {
        var element = this.materials1[index];
        n++;
        object["Swatch"+n] = this.getMaterial(element).name;
      }

      for (let index = 0; index < this.materials2.length; index++) {
        var element = this.materials2[index];
        n++;
        object["Swatch"+n] = this.getMaterial(element).name;
      }

      for (let index = 0; index < this.materials3length; index++) {
        var element = this.materials3[index];
        n++;
        object["Swatch"+n] = this.getMaterial(element).name;
      }

      for (let index = 0; index < this.materials4.length; index++) {
        var element = this.materials4[index];
        n++;
        object["Swatch"+n] = this.getMaterial(element).name;
      }

      for (let index = 0; index < this.materials5.length; index++) {
        var element = this.materials5[index];
        n++;
        object["Swatch"+n] = this.getMaterial(element).name;
      }

      console.log(object);
      return object;
    },
    validate () {
      this.$refs.form.validate()
    },
    sendRequest: function(){
      if(this.$refs.form.validate()){

        var object = this.getMaterialField();

        
        fetch('https://www.artlesscms.actstudio.xyz/api/forms/submit/Swatches?token=a15be93e9cdb43ca2b3778c2077c26', {
          method: 'post',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
              form: object
          })
        })
        .then(entry => entry.json());

        this.dialog = false; 
        this.snackbar = true;
      }


    },
    hasMaterial: function(_id,key){
      if(key + 1 == 1){
        return this.materials1.includes(_id);
      }

      if(key + 1 == 2){
        return this.materials2.includes(_id);
      }

      if(key + 1 == 3){
        return this.materials3.includes(_id);
      }

      if(key + 1 == 4){
        return this.materials4.includes(_id);
      }

      if(key + 1 == 5){
        return this.materials5.includes(_id);
      }

      return false;
    },
    addMaterial: function(_id, key){

      if(key + 1 == 1){
        this.materials1.push(_id);
      }

      if(key + 1 == 2){
        this.materials2.push(_id);
      }

      if(key + 1 == 3){
        this.materials3.push(_id);
      }

      if(key + 1 == 4){
        this.materials4.push(_id);
      }

      if(key + 1 == 5){
        this.materials5.push(_id);
      }

    },
    removeMaterial: function(_id,key){

      if(key + 1 == 1){
        var aux = [];
        for (let index = 0; index < this.materials1.length; index++) {
          const element = this.materials1[index];

          if(element != _id){
            aux.push(element);
          }
        }

        this.materials1 = this.materials1.filter(mat => mat !== _id);

        //this.materials1 = aux;
      }

      if(key + 1 == 2){
        var aux = [];
        for (let index = 0; index < this.materials2.length; index++) {
          const element = this.materials2[index];
          if(element != _id){
            aux.push(_id);
          }
        }
        this.materials2 = this.materials2.filter(mat => mat !== _id);
        //this.materials2 = aux;
      }

      if(key + 1 == 3){
        var aux = [];
        for (let index = 0; index < this.materials3.length; index++) {
          const element = this.materials3[index];
          if(element != _id){
            aux.push(_id);
          }
        }
        this.materials3 = this.materials3.filter(mat => mat !== _id);
        //this.materials3 = aux;
      }

      if(key + 1 == 4){
        var aux = [];
        for (let index = 0; index < this.materials4.length; index++) {
          const element = this.materials4[index];
          if(element != _id){
            aux.push(_id);
          }
        }
        this.materials4 = this.materials4.filter(mat => mat !== _id);
        // this.materials4 = aux;
      }

      if(key + 1 == 5){
        var aux = [];
        for (let index = 0; index < this.materials5.length; index++) {
          const element = this.materials5[index];
          if(element != _id){
            aux.push(_id);
          }
        }
        this.materials5 = this.materials5.filter(mat => mat !== _id);
        // this.materials5 = aux;
      }
    },
    contains: function(){

    },
    getMaterial: function (_id) {
      var aux = {};
      var found = false;
      for (let index = 0; index < this.materials.length; index++) {
        const element = this.materials[index];

        if (element._id == _id) {
          aux = element;
          found = true;
        }
      }

      if(!found){
        return false;
      }else{
        return aux;
      }
    },
    getRelatedProduct(categoryId) {
      let aux = this.products.filter(
        (product) => (product.category._id = categoryId)
      );

      var item = aux[Math.floor(Math.random() * aux.length)];

      return item;
    },
    getFirstRelatedProduct(categoryId) {
      this.firstRelated = this.getRelatedProduct(categoryId);
    },
    getSecondRelatedProduct(categoryId) {
      this.secondRelated = this.getRelatedProduct(categoryId);
    },
    getRelated() {
      if (this.productLoaded && this.productsLoaded) {
        this.getFirstRelatedProduct(this.product.category.firstRelated._id);
        this.getSecondRelatedProduct(this.product.category.secondRelated._id);
      }
    },
    remove: function (material) {
      let aux = [];
      for (let index = 0; index < this.fabricsSelection.length; index++) {
        if (material != this.fabricsSelection[index]) {
          aux.push(this.fabricsSelection[index]);
        }
      }

      this.fabricsSelection = aux;
    },
    getMaterialCover: function (id) {
      var aux = false;
      for (let ind = 0; ind < this.materials.length; ind++) {
        if (this.materials[ind]._id == id) {
          aux = this.materials[ind].cover.path;
        }
      }

      return aux;
    },
  },
  watch: {
    ex: function(val){


      setTimeout(() => {
        
        if(this.ex == 0){
          this.$vuetify.goTo('#description-header');
        }
  
        if(this.ex == 1){
          this.$vuetify.goTo('#dimensions-header');
        }
  
        if(this.ex == 2){
          this.$vuetify.goTo('#materials-header');
        }
  
        if(this.ex == 3){
          this.$vuetify.goTo('#cares-header');
        }
        if(this.ex == 4){
          this.$vuetify.goTo('#swatches-header');
        }
      }, 500);
    },  
    showFabrics: function (val) {
      console.log(this.$route.query);
      if (val) {
        // element which needs to be scrolled to
        var element = document.querySelector("#fabricsContainer");

        if(this.$route.query.showSwatches){
        }else{
          if(this.$route.query.hasOwnProperty('serie')){
            window.history.pushState(null, null, this.$route.fullPath+'&showSwatches=true');
          }else{

            window.history.pushState(null, null, this.$route.fullPath+'?showSwatches=true');
          }

        }

        // scroll to element
        element.scrollIntoView({ behavior: "smooth" });
      }else{

        window.history.pushState(null, null, this.$route.fullPath);
      }
    },
    $route: function () {
      this.show = false;
      var aux = this;
      fetch(
        "https://www.artlesscms.actstudio.xyz/api/collections/get/Products?token=a15be93e9cdb43ca2b3778c2077c26",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            filter: {
              url: this.$route.params.url,
            },
            populate: 3, // resolve linked collection items
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => (this.product = res.entries[0]))
        .then(function (res) {
          aux.fabricsSelected = aux.product.swatch[0]._id + "-" + 0;
          aux.show = true;
          aux.carouselIndex = 0;
        })
        .then(() => this.getRelated());
    },
  },
  computed: {
    path: function () {
      return this.$route.fullPath;
    },
    width: function () {
      console.log(this.$vuetify);
      return this.$vuetify.breakpoint.width;
    },
    alto: function () {
      if (this.$vuetify.breakpoint.width >= 2300) {
        if (this.$vuetify.breakpoint.width >= 3500) {
          return 110;
        } else {
          return 110;
        }
      } else {
        if (this.$vuetify.breakpoint.width >= 2300) {
          return 83;
        } else {
          return 55;
        }
      }
    },
    ancho: function () {
      if (this.$vuetify.breakpoint.width >= 2300) {
        if (this.$vuetify.breakpoint.width >= 2300) {
          return 368;
        } else {
          return 368;
        }
      } else {
        if (this.$vuetify.breakpoint.width >= 3500) {
          return 276;
        } else {
          return 184;
        }
      }
    },
    alto_iconos: function () {
      if (this.$vuetify.breakpoint.width >= 2300) {
        if (this.$vuetify.breakpoint.width >= 2300) {
          return 90;
        } else {
          return 40;
        }
      } else {
        return 30;
      }
    },
    ancho_iconos: function () {
      if (this.$vuetify.breakpoint.width >= 2300) {
        if (this.$vuetify.breakpoint.width >= 3500) {
          return 90;
        } else {
          return 40;
        }
      } else {
        return 30;
      }
    },
    variation: function () {
      if(this.product.variationLink != undefined){
        if(this.product.variationLink != null){
          return true
        }else{
          return false
        }
      }else{
        return false
      }
    }
  },
  mounted: function() {
    var aux = this;
    this.$emit("update", 0);

    if(this.$route.query.showSwatches){
      setTimeout(() => {
        this.showFabrics = true;
      }, 1500);
    }
    gtag('config', 'UA-26953667-1', {
      'page_title' : 'Product '+aux.$route.params.url,
      'page_path': '/product'+aux.$route.params.url
    });
  },
};
</script>


<style lang="scss">
.v-expansion-panel-content__wrap {
  padding-top: 30px;
}
</style>